<div id="subscribe" class="newsletter-section">
  <div class="div-block-4">
    <div class="book-thumbnail"><img src="assets/project/images/Logo-reference-2.jpg" sizes="175px"
        srcset="assets/project/images/Logo-reference-2-p-500.jpeg 500w, assets/project/images/Logo-reference-2-p-800.jpeg 800w, assets/project/images/Logo-reference-2.jpg 1024w"
        alt="Decorative image" class="image-9"></div>
    <h2 class="heading purpose-heading newsletter">Begin the Journey</h2>
    <div class="body nb">Enter your email below to receive updates on<br>The Guru Granth Sahib Project.</div>
    <div class="html-embed w-embed"><!--  Begin Mailchimp Signup Form  -->
      <link href="https://cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
      <style type="text/css">
        #mc_embed_signup {
          background: #F2EEE3;
          clear: left;
          font: 14px Helvetica, Arial, sans-serif;
          width: 100%;
        }

        /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
                 We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
      </style>
      <div id="mc_embed_signup">
        <form action="https://sikhri.us3.list-manage.com/subscribe/post?u=d5db8efd25e1eb6c223614a45&amp;id=5f9bc42dce"
          method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate"
          target="_blank" novalidate="">
          <div id="mc_embed_signup_scroll">
            <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address"
              required="">
            <!--  real people should not fill this in and expect good things - do not remove this or risk form bot signups -->
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
                name="b_d5db8efd25e1eb6c223614a45_5f9bc42dce" tabindex="-1" value=""></div>
            <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe"
                class="button"></div>
          </div>
        </form>
      </div>
      <!-- End mc_embed_signup -->
    </div>
    <div class="form-block w-form">
      <form id="email-form" name="email-form" data-name="Email Form"
        action="https://sikhri.us3.list-manage.com/subscribe/post?u=d5db8efd25e1eb6c223614a45&amp;amp;id=b0ba7f5713"
        method="post" class="form" data-wf-page-id="5db2238fbc53f83e37cb249a"
        data-wf-element-id="31e8108f-0916-48e0-b014-cf2608a9ad44" (ngSubmit)="onSubscribe()" [formGroup]="subscribeForm">
        <div class="d-flex flex-column">
          <label for="firstName" class="d-none">First Name:</label>
          <input class="field w-input" data-name="First Name" pattern="^[a-zA-Z\s'-]{2,50}$"
            placeholder="First Name" type="text" id="firstName" name="firstName" maxlength="256" required
            formControlName="firstName">
          <div class="error-message-container">
            <div *ngIf="subscribeForm.get('firstName')?.hasError('required') && submitted" class="error-message">
              First Name is required.
            </div>
            <div *ngIf="subscribeForm.get('firstName')?.hasError('pattern') && submitted" class="error-message"> 
              Please enter a valid first name address.
            </div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <label for="email" class="d-none">Email:</label>
          <input class="field w-input" data-name="Email" pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
            placeholder="Email Address" type="email" id="email" name="email" maxlength="256" required
            formControlName="emailID">
          <div class="error-message-container">
            <div *ngIf="subscribeForm.get('emailID')?.hasError('required') && submitted" class="error-message-email">
              Email is required.
            </div>
            <div *ngIf="subscribeForm.get('emailID')?.hasError('email') && submitted" class="error-message-email">
              Please enter a valid email address.
            </div>
          </div>
        </div>

        <input type="submit" data-wait="Please wait..." class="cta-button newsletter w-button" value="Submit" />
        <!-- <br /> -->
        
      </form>
      <div *ngIf="submitted && subscribed" [ngClass]="subscribed ? 'w-form-done' : 'w-form-fail'">
        <span>{{subscribeText}}</span>
      </div>
    </div>
  </div>
</div>